import React from 'react';
import { motion } from 'framer-motion';
import { BuyButton } from './BuyButton';
export function PricingCTA() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-130">
      <div className="container mx-auto px-4 relative z-10" data-id="element-131">
        <div className="max-w-3xl mx-auto text-center" data-id="element-132">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-16" data-id="element-133">
            <h2 className="text-4xl font-bold text-purple-900 mb-8 font-serif" data-id="element-134">
              Pregunta Honesta
            </h2>
            <p className="text-xl text-gray-700 mb-4" data-id="element-135">
              Si hoy estás en el Día 3 sin dinero…
            </p>
            <p className="text-2xl font-bold text-pink-600 mb-10" data-id="element-136">
              ¿Puedes permitirte que la próxima quincena sea igual?
            </p>

            <div className="space-y-4 text-lg text-gray-700 mb-12" data-id="element-137">
              <p data-id="element-138">
                No necesitas ganar más.{' '}
                <span className="font-bold text-purple-900" data-id="element-139">
                  Necesitas sistema.
                </span>
              </p>
              <p data-id="element-140">
                No necesitas culpa.{' '}
                <span className="font-bold text-purple-900" data-id="element-141">
                  Necesitas claridad.
                </span>
              </p>
              <p className="mt-6" data-id="element-142">
                En 15 días puedes pasar de supervivencia financiera…
              </p>
              <p className="text-2xl font-bold text-amber-600" data-id="element-143">
                A control consciente.
              </p>
            </div>

            <div className="bg-[#F5F0FF] rounded-3xl p-8 md:p-12 shadow-lg border border-purple-100" data-id="element-144">
              <h3 className="text-3xl font-bold text-purple-900 mb-6" data-id="element-145">
                Tu Próxima Quincena Puede Ser Diferente
              </h3>
              <p className="text-lg text-gray-700 mb-8" data-id="element-146">
                No el próximo mes. No cuando “todo mejore”. No cuando ganes más.
              </p>
              <p className="text-3xl font-bold text-pink-600 mb-8 uppercase tracking-wider" data-id="element-147">
                Ahora.
              </p>

              <div className="flex flex-col items-center justify-center mb-10" data-id="element-148">
                <p className="text-gray-500 line-through text-2xl mb-1" data-id="element-149">
                  Valor regular: $47.00
                </p>
                <div className="flex items-start justify-center" data-id="element-150">
                  <span className="text-3xl font-bold text-purple-900 mt-2" data-id="element-151">
                    $
                  </span>
                  <span className="text-7xl font-bold text-purple-900 tracking-tighter" data-id="element-152">
                    9.97
                  </span>
                  <span className="text-xl text-purple-900 mt-8 ml-1" data-id="element-153">USD</span>
                </div>
                <p className="text-pink-600 font-semibold mt-2" data-id="element-154">
                  Incluye los 2 bonos gratis
                </p>
              </div>

              <BuyButton text="EMPIEZA TU RESET HOY" className="w-full md:w-auto md:px-12 py-5 text-xl" data-id="element-155" />

              <div className="mt-8 space-y-2 text-xl font-medium text-purple-900" data-id="element-156">
                <p data-id="element-157">Haz el reset.</p>
                <p data-id="element-158">Respira.</p>
                <p data-id="element-159">Recupera el control.</p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="mt-16 pt-10 border-t border-gray-200" data-id="element-160">
            <h4 className="text-2xl font-bold text-purple-900 mb-4 font-serif" data-id="element-161">
              <span className="mr-2" data-id="element-162">📘</span> QUINCENA SIN ANSIEDAD
            </h4>
            <p className="text-lg text-gray-600 font-medium" data-id="element-163">
              15 días. Un sistema. Una nueva relación con tu dinero.
            </p>
            <p className="text-lg text-pink-600 font-bold mt-4" data-id="element-164">
              Empieza hoy y transforma tu próxima quincena.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}